import { translate } from '@netexknowledge/smart-xapi-event-translator';
import * as uuid from 'uuid/v4';
import { sendStatements } from '../api/discussionApi';

export const addNewAccessToDiscussion = (discussionId, userId, sectionId, tenantId, role) => {
  const statement = {
    context: {
      sectionId,
      userId,
      role: role,
      tenantId
    },
    activityId: discussionId,
    typeActivity: 'https://w3id.org/xapi/smart/activity/discussion',
    typeEvent: 'accessDiscussion',
    xapiData: {
      timestamp: new Date().getTime()
    }
  };
  return manageStatement(statement);
};

export const addNewMessageToDiscussion = (discussionId, user, sectionId, tenantId, message) => {
  const statement = {
    context: {
      sectionId,
      userId: user._id,
      role: user.role,
      tenantId
    },
    activityId: discussionId,
    typeActivity: 'https://w3id.org/xapi/smart/activity/discussion',
    xapiData: {
      timestamp: new Date().getTime(),
      message: {
        id: `http://id.tincanapi.com/activitytype/forum-topic#discussion?forum-topic=${uuid()}`,
        content: message
      },
      extendedUserData: {
        smartUserName: `${user.name} ${user.surname}`,
        smartUserAvatar: user.picture
      }
    },
    typeEvent: 'postDiscussionTopic'
  };
  return manageStatement(statement);
};

export const updateMessage = (discussionId, user, sectionId, tenantId, message, messageId) => {
  const statement = {
    context: {
      sectionId,
      userId: user._id,
      role: user.role,
      tenantId
    },
    activityId: discussionId,
    typeActivity: 'https://w3id.org/xapi/smart/activity/discussion',
    xapiData: {
      timestamp: new Date().getTime(),
      message: {
        id: messageId,
        content: message
      },
      extendedUserData: {
        smartUserName: `${user.name} ${user.surname}`,
        smartUserAvatar: user.picture
      }
    },
    typeEvent: 'postDiscussionTopic'
  };
  return manageStatement(statement);
};

export const addReplyToMessage = (discussionId, user, sectionId, tenantId, message, replyTo) => {
  const statement = {
    context: {
      sectionId,
      userId: user._id,
      role: user.role,
      tenantId
    },
    activityId: discussionId,
    typeActivity: 'https://w3id.org/xapi/smart/activity/discussion',
    xapiData: {
      timestamp: new Date().getTime(),
      message: {
        id: `http://id.tincanapi.com/activitytype/forum-topic#discussion?forum-topic=${uuid()}`,
        content: message
      },
      repliedMessage: {
        id: replyTo
      },
      extendedUserData: {
        smartUserName: `${user.name} ${user.surname}`,
        smartUserAvatar: user.picture
      }
    },
    typeEvent: 'replyToDiscussionMessage'
  };
  return manageStatement(statement);
};

export const removeMessageFromDiscussion = (discussionId, user, sectionId, tenantId, messageId) => {
  const statement = {
    context: {
      sectionId,
      userId: user._id,
      role: user.role,
      tenantId
    },
    activityId: discussionId,
    typeActivity: 'https://w3id.org/xapi/smart/activity/discussion',
    xapiData: {
      timestamp: new Date().getTime(),
      deletedMessage: {
        id: messageId
      }
    },
    typeEvent: 'deleteDiscussionMessage'
  };
  return manageStatement(statement);
};

export const addLikeToMessage = (discussionId, user, sectionId, tenantId, messageId) => {
  const statement = {
    context: {
      sectionId,
      userId: user._id,
      role: user.role,
      tenantId
    },
    activityId: discussionId,
    typeActivity: 'https://w3id.org/xapi/smart/activity/discussion',
    xapiData: {
      timestamp: new Date().getTime(),
      handledMessage: {
        id: messageId
      }
    },
    typeEvent: 'likeDiscussionMessage'
  };
  return manageStatement(statement);
};

// Aux functions

function manageStatement(statement) {
  const { statements, errors } = translate(statement);
  if (errors.length) {
    return new Promise(reject => reject(errors));
  }
  return sendStatements(statements);
}
